module.exports = __webpack_public_path__ + "img/stock3.52bbf69d.png";